// KWANKGM02060_借入相談内容照会（連帯債務者等）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import Agreement from '../../templates/Agreement';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import FooterBorrowingConsultationDetailsInquiry from '../../organisms/FooterBorrowingConsultationDetailsInquiry';
import { KWANKGM02060A01, KWANKGM02060A02 } from '../../const/api_modules';
import LoadingModal from '../../molecules/LoadingModal';

interface Props {
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  reception_cd: string;

  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  agreements: {
    guarantor: string;
    title: string;
    text: string;
  };
  guarantors_num: number;
  guarantor_info: GuarantorInfo;
  show_error_nav: boolean;
  display_status: boolean;
  requestModule: (module_name: string) => Promise<any>;
  is_loading: boolean;
  is_disagree: boolean;
  setShowErrorNav: React.Dispatch<React.SetStateAction<boolean>>;
  is_guarantor_agreement: boolean;
  setIsGuarantorAgreement: React.Dispatch<React.SetStateAction<boolean>>;
}

const BorrowingConsultationContentInquiry: React.FC<Props> = ({
  label,
  status_name,
  display_reception_cd,
  guide_text,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  looks_inactive,
  reception_id,
  reception_cd,
  status_code,
  agreements,
  guarantors_num,
  guarantor_info,
  show_error_nav,
  display_status,
  requestModule,
  is_loading,
  is_disagree,
  setShowErrorNav,
  is_guarantor_agreement,
  setIsGuarantorAgreement,
}) => {
  return (
    <>
      <TopArea
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        looks_inactive={looks_inactive}
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={requestModule}
        guarantor_info={guarantor_info}
        setShowErrorNav={setShowErrorNav}
      />

      <Agreement
        guarantor={agreements.guarantor}
        title={agreements.title}
        text={agreements.text}
        is_disagree={is_disagree}
        setIsGuarantorAgreement={setIsGuarantorAgreement}
      />
      <FooterBorrowingConsultationDetailsInquiry
        is_changing={false}
        is_staff={false}
        reception_cd={reception_cd}
        reception_id={reception_id}
        clickAgree={() => requestModule(KWANKGM02060A01)}
        clickDisagree={() => requestModule(KWANKGM02060A02)}
        status_code={status_code}
        is_guarantor_agreement={is_guarantor_agreement}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default BorrowingConsultationContentInquiry;
